/* eslint-disable react/prop-types */

import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import Icon from "@mui/material/Icon";
import { useSoftUIController, setMiniSidenav } from "context";
import SoftTypography from "components/SoftTypography";

function Headerk({ topTab, setTopTab }) {
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav } = controller;

  const sidenavWidth = miniSidenav ? 0 : 0;

  const topTabs = ["Settings"];

  const topTabStyle = (tab) => ({
    cursor: "pointer",
    fontWeight: 500,
    color: topTab === tab ? "#fff" : "rgba(255,255,255,0.8)",
    borderBottom: topTab === tab ? "2px solid #00c2ff" : "none",
    fontSize: "1rem",
    transition: "all 0.2s ease",
  });

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);

  return (
    <>
      {/* Top Bar – Dark Blue Background */}
      <Box
        sx={{
          background: "linear-gradient(87deg, rgb(41, 88, 182) 0, rgb(40, 62, 152) 100%)",
          width: `calc(100% - ${sidenavWidth}px)`,
          transition: "margin-left 0.3s ease, width 0.3s ease",
          px: { xs: 2, md: 3 },
          py: 1,
          borderRadius: "10px",
          color: "#fff",
          boxShadow: "0px 4px 20px rgba(0,0,0,0.15)",
        }}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box display="flex" alignItems="center">
          {topTabs.map((tab) => (
            <SoftTypography fontWeight="medium" key={tab} sx={topTabStyle(tab)} onClick={() => setTopTab(tab)}>
              {tab}
            </SoftTypography>
          ))}
        </Box>

        <IconButton
          size="small"
          onClick={handleMiniSidenav}
          sx={{
            color: "#fff",
            "&:hover": {
              background: "rgba(255,255,255,0.15)",
            },
          }}
        >
          <Icon>{miniSidenav ? "menu_open" : "menu"}</Icon>
        </IconButton>
      </Box>
    </>
  );
}

export default Headerk;